import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Container, Hidden, AppBar } from "@material-ui/core";

import {
  getPrestador,
  getContactoPrestador,
} from "../../redux/selectors/index";
import styles from "./styles.styles";
import { BtnIngresarDatos } from "./ingresarDatos";
import { openModalDatos } from "../../redux/actions/modalActions";

export default () => {
  const classes = styles();
  const dispatch = useDispatch();

  const prestador = useSelector((state) => getPrestador(state));
  const prestadorDatos = useSelector((state) => getContactoPrestador(state));

  const openModal = () => dispatch(openModalDatos(true));

  return (
    <AppBar className={classes.container}>
      <Container className={classes.containerDatos}>
        <Hidden xsDown>
          <img
            className={classes.logo}
            src="https://salud.galeno.com.ar/static/media/logoGaleno700.530a2109.png"
            alt="/"
          />
        </Hidden>
        <Hidden smUp>
          <img
            className={classes.logoChiquito}
            src="https://salud.galeno.com.ar/static/media/logoGaleno700.530a2109.png"
            alt="/"
          />
        </Hidden>
        <Container disableGutters={true} className={classes.containerDatos}>
          <Hidden xsDown>
            <img
              src="https://www.e-galenomovil.com.ar/assets/img/logoPrestador.png"
              alt="/"
            />
            <Typography className={classes.codPresta} color="textSecondary">
              {prestador}
            </Typography>
          </Hidden>
          <BtnIngresarDatos
            color="primary"
            variant="outlined"
            onClick={openModal}
          >
            {prestadorDatos ? "Editar mis Datos" : "Ingresar mis Datos"}
          </BtnIngresarDatos>
        </Container>
      </Container>
    </AppBar>
  );
};
